import { focusSelector } from './getFocusSelector';

const previousTabIndexLabel = 'data-previous-tabindex';

/**
 * Deshabilita la posibilidad de hacer foco en
 * todos los descendientes de parent. Es
 * especialmente útli cuando se ocultan elementos
 * del DOM sin quitarlos, cuando por accesibilidad
 * es importante que el foco no alcance a dichos
 * métodos.
 */
export function disableChildrenFocus(parent: HTMLElement) {
  const focusElement = parent.querySelectorAll(focusSelector);
  focusElement.forEach((element) => {
    element.setAttribute(
      previousTabIndexLabel,
      element.getAttribute('tabindex') ?? '',
    );
    element.setAttribute('tabindex', '-1');
  });
}

/**
 * Restaura el foco de los hijos de parent a los
 * que previamente se les había quitado el foco
 * con disableChildrenFocus.
 */
export function enableChildrenFocus(parent: HTMLElement) {
  const focusElement = parent.querySelectorAll(`[${previousTabIndexLabel}]`);
  focusElement.forEach((element) => {
    element.setAttribute(
      'tabindex',
      element.getAttribute(previousTabIndexLabel) ?? '0',
    );
    element.removeAttribute(previousTabIndexLabel);
  });
}
